const colorSchemes = {
    default: 'default',
    redBlackWhite: 'red_black_white',
    hoff: 'hoff',
    petrovich: 'petrovich',
    emc: 'emc',
    optima: 'optima',
    samberi: 'samberi',
    mts: 'mts',
    raif: 'raif',
    baucenter: 'baucenter'
}
export { colorSchemes }

const layouts = {
    default: 'default',
    col2: 'col-2',
    col2State: 'col-2-state',
    col2DiffClients: 'col-2-diff-clients',
    col3: 'col-3',
    col3Flag: 'col-3-flag',
    colAd: 'col-ad',
    col1Ad: 'col-1-ad',
    col2Ad: 'col-2-ad',
    doubleStatus: 'double-status'
}
export { layouts }

const settings = {
  colorScheme: [
    {
      code: colorSchemes.default
    },
    {
      code: colorSchemes.petrovich
    },
    {
      code: colorSchemes.redBlackWhite,
      colors: [
        {
          name: '--color-text',
          value: '#000000'
        },
        {
          name: '--color-title',
          value: '#999AA0'
        },
        {
          name: '--color-highlighty',
          value: '#ED1C24'
        },
        {
          name: '--color-background',
          value: '#fff'
        },
        {
          name: '--color-icons',
          value: '#C1C2C2'
        },
        {
          name: '--color-animate',
          value: '#fff'
        }
      ]
    },
    {
      code: colorSchemes.hoff,
      colors: [
        {
          name: '--color-text',
          value: '#000000'
        },
        {
          name: '--color-title',
          value: '#7D6E78'
        },
        {
          name: '--color-highlighty',
          value: '#E60000'
        },
        {
          name: '--color-background',
          value: '#FFF'
        },
        {
          name: '--color-icons',
          value: '#7D6E78'
        },
        {
          name: '--color-animate',
          value: '#FFF'
        },
        {
          name: '--font-title',
          value: 'Neue-Frutiger-World'
        },
        {
          name: '--font-main',
          value: 'Neue-Frutiger-World'
        }
      ]
    },
    {
      code: colorSchemes.emc,
      colors: [
        {
          name: '--color-text',
          value: '#0E0D0D'
        },
        {
          name: '--color-title',
          value: '#868686'
        },
        {
          name: '--color-highlighty',
          value: '#8C3332'
        },
        {
          name: '--color-icons',
          value: '#8C3332'
        }
      ]
    },
    {
      code: colorSchemes.optima,
      colors: [
        {
          name: '--color-highlighty',
          value: '#EC1C24'
        },
        {
          name: '--color-icons',
          value: '#EC1C24'
        },
        {
          name: '--font-title',
          value: 'TT_Norms_Pro'
        },
        {
          name: '--font-main',
          value: 'TT_Norms_Pro'
        }
      ]
    },
    {
      code: colorSchemes.samberi,
      colors: [
        {
          name: '--color-right-state',
          value: '#1E664A'
        },
        {
          name: '--color-highlighty',
          value: '#C01130'
        }
      ]
    },
    {
      code: colorSchemes.mts,
      colors: [
        {
          name: '--color-highlighty',
          value: '#FF0032'
        },
        {
          name: '--color-icons',
          value: '#FF0032'
        },
        {
          name: '--color-title',
          value: '#7E7E8E'
        },
        {
          name: '--font-title',
          value: 'MTSCompact'
        },
        {
          name: '--font-main',
          value: 'MTSCompact'
        }
      ]
    },
    {
      code: colorSchemes.raif,
      colors: [
        {
          name: '--color-highlighty',
          value: '#FEE600'
        },
        {
          name: '--color-icons',
          value: '#363432'
        },
        {
          name: '--color-text',
          value: '#2B2D33'
        },
        {
          name: '--color-title',
          value: '#2B2D33'
        },
        {
          name: '--font-title',
          value: 'Navigo'
        },
        {
          name: '--font-main',
          value: 'Navigo'
        },
        {
          name: '--logo-size-height',
          value: '90px'
        },
        {
          name: '--logo-size-width',
          value: '100px'
        }
      ]
    },
    {
      code: colorSchemes.baucenter,
        colors: [
            {
              name: '--color-highlighty',
              value: '#002855'
            },
            {
              name: '--color-icons',
              value: '#c8102eff'
            },
            {
              name: '--color-title',
              value: 'none'
            },
            {
              name: '--font-title',
              value: 'DIN-2014'
            },
            {
              name: '--font-main',
              value: 'Formular-Medium'
            },
            {
              name: '--font-time',
              value: 'Formular-Medium'
            },
            {
                name: '--logo-size-height',
                value: '150px'
            },
            {
                name: '--logo-size-width',
                value: '500px'
            },
            {
                name: '--color-background-header',
                value: '#002855'
            },
            {
                name: '--color-time',
                value: 'white'
            },
            {
                name: '--background-table-queue',
                value: 'white'
            },
            {
                name: '--background-table-cols',
                value: 'white'
            },
            {
                name: '--order-table-cols',
                value: '0'
            },
            {
                name: '--order-table-ad-playlist',
                value: '1'
            },
            {
                name: '--padding-table-ad-playlist',
                value: '0 0 0 50px'
            },
            {
                name: '--block-padding',
                value: '0 40px 0 40px'
            },
            {
                name: '--margin-block-wrapper',
                value: '0 15px 100px 15px'
            },
            {
                name: '--block-max-width',
                value: 'none'
            },
            {
                name: '--width-table-cols_col-1',
                value: '30%'
            },
            {
                name: '--width-table-ad-playlist',
                value: '70%'
            },
            {
                name: '--padding-table-cols_col-1',
                value: 'none'
            },
            {
                name: '--font-size-ticket_col-1',
                value: '65px'
            },
            {
                name: '--padding-table-queue-header',
                value: '2vh 0 2vh 2vw  '
            },
            {
                name: '--font-weight-time',
                value: '600'
            },
            {
                name: '--height-table-cols',
                value: 'auto'
            },
            {
                name: '--flex-ticket-number',
                value: '2'
            },
            {
                name: '--block-padding',
                value: '0'
            },
            {
                name: '--queue-header-border-radius',
                value: '0 0 32px 32px'
            },
            {
                name: '--color-text-short',
                value: 'white'
            },
            {
                name: '--logo-size-height',
                value: '14vh'
            },
            {
                name: '--logo-size-width',
                value: '28vw'
            },
            {
                name: '--ut-margin-top',
                value: '3vh'
            },
            {
                name: '--ut-column-0-background',
                value: '#F1F7FF'
            }
          ]
    }
  ],
  layout: [
    {
      code: layouts.default,
      sizeLandscape: 4,
      sizePortrait: 10
    },
    {
      code: layouts.col2,
      sizeLandscape: 10,
      sizePortrait: 12
    },
    {
      code: layouts.col3,
      sizeLandscape: 18,
      sizePortrait: 18
    },
    {
      code: layouts.col3Flag,
      sizeLandscape: 18,
      sizePortrait: 18
    },
    {
      code: layouts.col2State,
      sizeLandscape: 30,
      sizePortrait: 30
    },
    {
      code: layouts.col2DiffClients,
      sizeLandscape: 10,
      sizePortrait: 12
    },
    {
      code: layouts.colAd,
      sizeLandscape: 4,
      sizePortrait: 10
    },
    {
      code: layouts.col1Ad,
      sizeLandscape: 4,
      sizePortrait: 5
    },
    {
      code: layouts.col2Ad,
      sizeLandscape: 10,
      sizePortrait: 12
    },
    {
      code: layouts.doubleStatus,
      sizeLandscape: null,
      sizePortrait: null
    }
  ]
}
export { settings }

const browsers = {
    chrome: 'chrome',
    chromeMinSupportVersion: 80,
    firefox: 'firefox',
    firefoxMinSupportVersion: 75
}
export { browsers }
